// extracted by mini-css-extract-plugin
export default {"component":"mdezD","block":"jbV4z"};